/**
 * @desc 校验
 * @author Jooger <iamjooger@gmail.com>
 * @date 11 Dec 2017
 */

'use strict'

// const idCard = require('idcard')

/**
 * 类型检测
 * @param {*} obj 检测对象
 * @param {String | Array[String]} type 类型（数组）
 */
export const isType = (obj = {}, type = 'Object') => {
  if (!Array.isArray(type)) {
    type = [type]
  }
  return type.some(t => Object.prototype.toString.call(obj) === `[object ${t}]`)
}

/**
 * 校验手机号码
 * @param  {} phone=''  手机号码
 */
export const isPhoneNo = (phone = '') => /^1[34578]\d{9}$/.test(phone)

// export const isIDCard = (card = '') => {
//   const info = idCard.info(card)
//   return info.valid ? info : info.valid
// }





// WEBPACK FOOTER //
// ./src/utils/validate.js